"use client";

import GradientText from "../GradientText";
import CallButton from "../button/CallButton";
import CatalogButton from "../button/CatalogButton";
import LandingSection from "../LandingSection";
import Model3D from "@/components/Model3D";

export default function Hero() {
  return (
    <LandingSection tagTitle="به اسمارت خوش آمدید" className="relative">
      <div className="flex w-full justify-between items-center px-5 lg:px-10 flex-wrap lg:flex-nowrap ">
      <div className="text-xl relative z-50 mx-auto lg:mx-0 lg:pr-10  fade-in space-y-4 order-2 lg:order-1">
          <div className={ "text-[5.5vw] xs:text-2xl text-center lg:text-start lg:text-3xl font-bold"}>
        
         
            <h1 className=""> <GradientText className="text-3xl lg:text-[40px]"/> تلفیق هوشمند کیفیت و فناوری  </h1>
                     </div>
          <div
              className="   space-y-2 ">
              <div className="text-[4vw] xs:text-base text-center lg:text-start  text-white lg:text-xl">تنها نماینده انحصاری برندهای محبوب <span
                  className={"font-black "}>EKO</span> و <span className={"font-black "}>DEFNE BANYO</span> در سراسر ایران.
              </div>
              <div className="text-sm text-center lg:text-start  text-mute lg:text-base">واردکننده تخصصی محصولات لوکس و هوشمند حمام، آشپزخانه و سرویس بهداشتی</div>
          </div>


          <div className="w-full  justify-center lg:justify-start  space-x-3 !mt-6 flex items-center">
            <CatalogButton />
            <CallButton />
          </div>

        </div>
        <div className="relative order-1 lg:order-2 mb-10 lg:mb-0  w-full h-[400px] lg:w-[475px] lg:h-[475px]">
          <Model3D />
        </div>
      </div>

    </LandingSection>
  );
}
